import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import axios from 'axios';

import AppBar from './AppBar';
import SideMenuNavList from './SideMenuNavList';
import SideMenuDrawer from './SideMenuDrawer';
import NotificationsMenu from '../../components/NotificationsMenu';
import Account from '../../pages/Account';
import Opinions from '../../pages/Opinions/';
import Notifications from '../../pages/Notifications';
import Memberships from '../../pages/Memberships';
import Messages from '../../pages/Messages/';
import Home from '../../pages/Home/';
import Profile from '../../pages/Profile';
import Progress from '../../pages/Profile/Progress/';
import * as ROUTES from '../../routes';
import Analytics from '../../pages/Analytics';
import SignIn from '../../pages/SignIn/';
import EconomicProposal from '../../pages/EconomicProposal';
import FooterContainer from '../../components/Footers/FooterContainer';
import HeaderContainer from '../../components/Headers/HeaderContainer';
import FullScreenLoader from '../../components/FullScreenLoader';
import TabPanel from '../../components/AdditionalInfo/Content/index'
import { UserIsAuthenticated } from '../../routes/Guard'
import { USER_STATUS } from "../../types/UserTypes";
import Payments from "../../pages/Payments";
import LoginSwitcher from './LoginSwitcher';
import Tutorials from "../../pages/Tutoriales";

// const drawerWidthExpanded = 214;
// const drawerWidthContracted = 79;
const mobileHeightTopAppBar = 56;
const desktopHeightTopAppBar = 64;

const styles = () => ({
  root: {
    display: 'flex',
  },
  content: {
    paddingTop: isMobile
      ? mobileHeightTopAppBar + 24
      : desktopHeightTopAppBar + 24,
    flexGrow: 1,
    // height: 'auto',
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#f6f8fb',
    overflow: 'hidden'
  },
});

const DashBoard = (props) => {
  const {
    classes,
    profile,
    notifications,
    statusUser,
    history,
    userRole,
    notificationsLaw,
    uid,
    modalPayments,
    membershipData,
  } = props
  const [expandSideMenu, setExpandSideMenu] = useState(true);
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadingFormData, setLoadingFormData] = useState(true);
  const [suscription, setSuscription] = useState({});

  useEffect(() => {
    if (userRole && userRole === 'cliente') {
      history.push("/usuario")
    }
    if (statusUser && statusUser === 3) {
      history.push("/ingreso-abogados")
    } else if (statusUser && statusUser === 2) {
      setLoadingFormData(false)
    }
  })

  useEffect(() => {
    membershipData && membershipData.idStripe && getSuscription(membershipData.idStripe)
  }, [])

  //   componentWillReceiveProps(props){
  //     if (props.statusUser === USER_STATUS.notFound){
  //         this.props.history.push("/ingreso-abogados ");
  //     }
  // }

  const tabletSize = useMediaQuery('(max-width: 768px)');

  const handleOpenMenu = name => event => {
    //event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = name => event => {
    event && event.preventDefault();
    setAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpenSideMenu(true);
  };

  const handleDrawerClose = () => {
    setOpenSideMenu(false);
  };

  const toggleSideMenu = () => {
    setExpandSideMenu(!expandSideMenu);
  };

  const toggleDrawer = event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    /* setState(prevState => ({ openSideMenu: !prevState.openSideMenu })); */
    setOpenSideMenu(!openSideMenu);
  };


  const getSuscription = (id) => {
    var config = {
      method: 'get',
      url: `${process.env.REACT_APP_FIREBASE_URLSERVICE_PAYMENT}/payments/getSubscriptionById?idCustomer=${id}`,
      headers: {
        'Authorization': 'Bearer TgC1n73rN37Gr0u9'
      }
    };
    axios(config)
      .then(function (response) {
        console.log(response)
        setSuscription(response.data.data[0])
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  return (
    <>


      {statusUser && statusUser === 2 ?
        (
          <div>
            <HeaderContainer
              isExpandedSideMenu={tabletSize ? openSideMenu : expandSideMenu}
              handleOpenSideMenu={tabletSize ? toggleDrawer : toggleSideMenu}
              handleOpenMenu={handleOpenMenu}
              openDrawer={openSideMenu}
              handleToggleDrawer={toggleDrawer}
            />



            <div style={{ maxWidth: 1920, margin: '0 auto' }}>
              <div style={{ maxWidth: 1360, margin: '0 auto' }}>
                <main className={classes.content}>
                  <div
                    style={
                      tabletSize
                        ? {
                          padding: 0,
                          display: 'flex',
                          justifyContent: 'flex-start',
                        }
                        : {
                          paddingLeft: 24,
                          display: 'flex',
                          justifyContent: 'flex-start',
                        }
                    }
                  >

                    {
                      history.location.pathname !== "/dashboard/payments" &&
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        {!tabletSize && (
                          <>
                            <LoginSwitcher expanded={expandSideMenu} />
                            <div className="dashboard-sideMenu">
                              <SideMenuNavList
                                expandDrawer={expandSideMenu}
                                isExpandedSideMenu={
                                  tabletSize ? openSideMenu : expandSideMenu
                                }
                                handleOpenSideMenu={
                                  tabletSize ? toggleDrawer : toggleSideMenu
                                }
                              //handleOpenMenu={handleOpenMenu('anchorEl')}
                              // variant="permanent"
                              />
                            </div>
                          </>
                        )}
                      </div>
                    }
                    <div
                      style={{
                        width: tabletSize
                          ? '100%'
                          : expandSideMenu
                            // ? 'calc(100% - 191px)'
                            ? '100%'
                            : 'calc(100% - 57px)',
                        // display: 'flex',
                        padding: tabletSize ? 0 : '0 16px',
                      }}
                    >
                      <Route
                        exact
                        path={ROUTES.HOME}
                        render={props => (
                          <Home
                            suscription={suscription}
                            {...props}
                            justifyContent={expandSideMenu ? 'flex-start' : 'center'}
                          ></Home>
                        )}
                      />
                      <Route
                        exact
                        path={ROUTES.PROFILE}
                        render={props => <Profile {...props}></Profile>}
                      />
                      <Route
                        exact
                        path={ROUTES.PAYMENTS}
                        render={props => <Payments {...props}></Payments>}
                      />


                      <Route
                        exact
                        path={ROUTES.ANALYTICS}
                        render={props => <Analytics {...props}></Analytics>}
                      />
                      <Route
                        exact
                        path={ROUTES.MEMBERSHIP}
                        render={props => <Memberships suscription={suscription} {...props} billing={membershipData} ></Memberships>}
                      />
                      <Route
                        exact
                        path={ROUTES.MEMBERSHIP_HISTORY}
                        render={props => <Memberships {...props} billing={membershipData} ></Memberships>}
                      />
                      <Route
                        exact
                        path={ROUTES.MEMBERSHIP_PAYMETHOD}
                        render={props => <Memberships {...props} billing={membershipData} ></Memberships>}
                      />
                      <Route
                        exact
                        path={ROUTES.MEMBERSHIP_INVOICES}
                        render={props => <Memberships {...props} billing={membershipData} ></Memberships>}
                      />
                      <Route
                        exact
                        path={ROUTES.MESSAGES}
                        render={props => <Messages userUid={uid} {...props}></Messages>}
                      />
                      <Route
                        exact
                        path={ROUTES.NOTIFICATIONS}
                        render={props => <Notifications userUid={uid} {...props}></Notifications>}
                      />
                      <Route
                        exact
                        path={ROUTES.TUTORIALES}
                        render={props => <Tutorials userUid={uid} {...props}></Tutorials>}
                      />
                      <Route
                        exact
                        path={ROUTES.ECONOMIC_PROPOSAL}
                        render={props => <EconomicProposal userUid={uid} {...props}></EconomicProposal>}
                      />
                      <Route
                        exact
                        path={ROUTES.OPINIONS}
                        render={props => <Opinions {...props}></Opinions>}
                      />
                      <Route
                        exact
                        path={ROUTES.ACCOUNT}
                        render={props => <Account {...props}></Account>}
                      />
                      <Route
                        exact
                        path={ROUTES.TERMS_CONDITIONS}
                        render={props => <TabPanel {...props}></TabPanel>}
                      />

                      {/* aqui va modal */}

                    </div>
                  </div>
                </main>
              </div>
            </div>


            <FooterContainer /> </div>) : <FullScreenLoader loading={loadingFormData} />}
    </>
  );
};


const mapStateToProps = state => ({
  uid: state.authClient.uid,
  statusUser: state.userState.statusUser,
  userRole: state.authClient.role,
  notificationsLaw: state.authClient.notificationsLaw,
  modalPayments: state.ModalReducer.openModalPayments,
  billing: state.billingReducer.billingData,
  membershipData: state.authClient.membershipData,
})



export default connect(mapStateToProps)(withStyles(styles)(DashBoard))